import { atom, DefaultValue, selector, useRecoilState } from "recoil";

type SnackBarStateType =
  | "create"
  | "update"
  | "delete"
  | "failed"
  | "cancel"
  | "confirm"
  | "default"
  | "login"
  | "copy";

export const snackBarState = atom<SnackBarStateType>({
  key: "snackBarState",
  default: "default",
});

export const snackBarToggleState = atom<boolean>({
  key: "snackBarToggle",
  default: false,
});

export const snackBarMessageState = selector({
  key: "snackBarMessageState",
  get: ({ get }) => {
    const message = get(snackBarState);
    get(snackBarToggleState);
    switch (message) {
      case "create":
        return "작업이 추가되었습니다.";
      case "update":
        return "작업이 변경되었습니다.";
      case "delete":
        return "작업이 삭제되었습니다.";
      case "cancel":
        return "작업이 취소되었습니다.";
      case "failed":
        return "작업이 실패되었습니다.";
      case "login":
        return "로그인에 성공했습니다.";
      case "copy":
        return "복사에 성공했습니다.";
      default:
        return null;
    }
  },
  // set: ({set}, newValue) => {
  //   newValue !== null ?? set(snackBarToggleState, true);
  // },
});
